import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { experiencePropType } from '../../../propTypes';
import { EntityRefData } from '../entityRefData';
import { ROUTES } from '../../../routes/routes';

export const ExperienceLink = ({ isKioskMode, kioskSlug, experience, children, ...props }) => {
  return (
    <EntityRefData entityType="markets" id={experience.market}>
      {({ slug: marketSlug } = {}) => {
        const linkUrl = isKioskMode
          ? ROUTES.kioskExperience(kioskSlug, experience.slug)
          : ROUTES.marketExperience(marketSlug, experience.slug);

        return (
          <Link to={linkUrl} {...props}>
            {children}
          </Link>
        );
      }}
    </EntityRefData>
  );
};

ExperienceLink.propTypes = {
  experience: experiencePropType,
  children: PropTypes.any,
  isKioskMode: PropTypes.bool,
  kioskSlug: PropTypes.string,
};
